import React, { useState, useEffect, useContext } from 'react';
import SettingService from "../../controller/SettingController/SettingController";
import SettingValueService from "../../controller/SettingValueController/SettingValueController";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { Link } from "react-router-dom";
import CreateSetting from "../Setting/CreateSetting";
import CreateSettingValue from "../SettingValue/CreateSettingValue";
import HelpSite from "../../../Common/HelpLink";
function GlobalSettingPage() {
    const navigate = useNavigate();
    const [settingList, setSettingList] = useState([]);
    const [settingValueList, setSettingValueList] = useState([]);
    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [currentSetting, setCurrentSetting] = useState(null);
    const [currentSettingValue, setCurrentSettingValue] = useState(null);
    const [isSettingModalOpen, setIsSettingModalOpen] = useState(false);
    const [isSettingValueModalOpen, setIsSettingValueModalOpen] = useState(false);

    const fetchSetting = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const settingData = await SettingService.GetAllSetting(redirectCallback);
            setSettingList(settingData);
            if (settingData.length > 0) {
                setCurrentSetting(settingData[0].PK_Settings_ID);
                fetchSettingValue(settingData[0].PK_Settings_ID);
            }
        } catch (error) {
            console.error('Error fetching settings:', error);
        }
    };

    useEffect(() => {
        fetchSetting();
    }, []);

    const fetchSettingValue = async (settingId) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const settingValueData = await SettingValueService.GetSettingValueBySettingID(settingId, redirectCallback);
            setSettingValueList(settingValueData);
        } catch (error) {
            console.error('Error fetching setting values:', error);
        }
    };

    const handleSettingClick = (settingId) => {
        setCurrentSetting(settingId);
        fetchSettingValue(settingId);
    };

    const handleCreateSettingClick = () => {
        setCurrentSetting(null);
        setIsSettingModalOpen(true);
    };

    const handleCreateSettingValueClick = () => {
        setCurrentSettingValue(null);
        setIsSettingValueModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsSettingModalOpen(false);
        setIsSettingValueModalOpen(false);
    };

    const handleEditSettingClick = (setting) => {
        setCurrentSetting(setting);
        setIsSettingModalOpen(true);
    };

    const handleDeleteSettingClick = async (settingId) => {
        const confirmed = window.confirm("Are you sure you want to delete this setting?");
        if (confirmed) {
            try {
                await SettingService.DeleteSetting(settingId);
                fetchSetting();
            } catch (error) {
                console.error('Error deleting setting:', error);
            }
        }
    };

    const handleEditSettingValueClick = (settingValue) => {
        setCurrentSettingValue(settingValue);
        setIsSettingValueModalOpen(true);
    };

    const handleDeleteSettingValueClick = async (settingValueId) => {
        const confirmed = window.confirm("Are you sure you want to delete this setting value?");
        if (confirmed) {
            try {
                await SettingValueService.DeleteSettingValue(settingValueId);
                fetchSettingValue(currentSetting);
            } catch (error) {
                console.error('Error deleting setting value:', error);
            }
        }
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                <div className="col-sm-12" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Global Setting" Module="26" />
                </div>
            </div>
            <div className="row mb-3">
                
                <div className="col-sm-12">
                    <Link className='btn btn-primary btn-sm' onClick={handleCreateSettingValueClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </Link>
                    <table className="table m-0 table-hover" style={{ marginTop: "8px" }}>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Value</th>
                                <th style={{ "textAlign": "right" }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {settingValueList.map((settingValue) => (
                                <tr key={settingValue.PK_SettingsValue_ID} onClick={() => handleEditSettingValueClick(settingValue.PK_SettingsValue_ID)}>
                                    <td>{settingValue.vc_ValueName}</td>
                                    <td dangerouslySetInnerHTML={{ __html: settingValue.vc_Value }}></td>
                                    <td style={{ "textAlign": "right" }}>

                                        
                                        <button className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleDeleteSettingValueClick(settingValue.PK_SettingsValue_ID)}>
                                            <i className="icofont-ui-delete" aria-hidden="true"></i>
                                        </button>


                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {isSettingValueModalOpen && (
                        <CreateSettingValue
                            setting={currentSettingValue}
                            SettingList={settingList}
                            onClose={handleCloseModal}
                            onSuccess={fetchSetting}
                        />
                    )}
                </div>
            </div>
        </div >
    );
}

export default GlobalSettingPage;
